export const copyMethods = {
  methods: {
    copy(value) {
      navigator.clipboard.writeText(value);
    }
  }
} 